export default __webpack_public_path__ + "static/media/324.c803146c.png";